"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNotFoundSection = exports.notFound = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var classNames = require("classnames");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var Login_1 = require("@/pages/common/components/Login");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.notFound), { lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1 || 'en', layout: state.layout })); };
var mapDispatchToProps = function () { return ({}); };
var renderNotFoundSection = function (props) { return (React.createElement("div", { className: "l-feature", style: { height: '100%' } },
    React.createElement("div", { className: "l-feature__container" },
        React.createElement("div", { className: "l-feature__main" },
            React.createElement("div", { className: "l-feature__title" }, props.title),
            React.createElement("div", { className: "l-feature__caption" },
                props.caption,
                React.createElement("br", null),
                props.or,
                ' ',
                React.createElement("a", { href: "/" + props.lang + "/communication/enquiry", className: "o-href" }, props.tellUs),
                "\u00A0 ",
                props.contactCaption),
            React.createElement("div", { className: "l-feature__actions" },
                React.createElement("a", { href: "/" + props.lang + "/property-search/buy", className: "o-btn o-btn--primary" },
                    React.createElement("span", { className: "fal fa-search" }),
                    props.searchForSale),
                React.createElement("a", { href: "/" + props.lang + "/property-search/rent", className: "o-btn o-btn--primary" },
                    React.createElement("span", { className: "fal fa-search" }),
                    props.searchForRent))),
        React.createElement("div", { className: "l-feature__side" },
            React.createElement("img", { src: "/res/img/404.jpg" }))))); };
exports.renderNotFoundSection = renderNotFoundSection;
exports.notFound = function (props) {
    var pageClass = classNames([
        'l-notfound',
        'c-nav--safari',
        {
            'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-nav__menu-setting--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
        },
    ]);
    return (React.createElement("div", { className: pageClass },
        React.createElement("div", { className: "l-notfound__row" },
            React.createElement(MegaMenu_1.default, { nobottom: true, hideSettings: true })),
        React.createElement("div", { className: "l-notfound__row l-notfound__row--flex" }, renderNotFoundSection(props)),
        React.createElement("div", { className: "l-notfound__row" },
            React.createElement(Megafoot_1.default, null)),
        React.createElement(Login_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.notFound);
